import { VideoNotification } from '@studio/design-system/video-notification';
import { useState, type ReactElement } from 'react';
import type { Wiring } from './wiring.js';

/** @internal */
export const Notifications = ({
  hasAnnotations,
  hasAssignment,
  hasNoWorkers,
  isAnnotationSelected,
  isConnected,
  isRedetecting,
  isReturningToSafePosition,
  isTracking,
  wantsTracking,
  trackingEngagedDeviceNames,
  handleRequestTransferTracking,
  handleStopTrackingSelectedSubject,
  safePositionCountdown,
  redetectionCountdown,
  isRestarting
  // @ts-ignore
}: Wiring): ReactElement => {
  const [safeWindowAutoTrackingLoading, _] = useState(false);

  if (safeWindowAutoTrackingLoading) {
    return <VideoNotification message='Auto Tracking is Loading...' variant='warning' />;
  }

  const [mountedAt] = useState(Date.now());
  const hasPassedTransferDelay = Date.now() - mountedAt > 1000;

  return (
    <>
      {!!hasNoWorkers && trackingEngagedDeviceNames.length === 0 && (
        <VideoNotification message='No GPUs Available.' variant='error' />
      )}
      {hasPassedTransferDelay && !!hasNoWorkers && trackingEngagedDeviceNames.length > 0 && (
        <VideoNotification
          message={`Tracking is in use on ${trackingEngagedDeviceNames[0]}`}
          variant='warning'
          canClose
          customCloseIcon='transfer'
          onClose={(): void => {
            void handleRequestTransferTracking();
          }}
        />
      )}
      {!hasAssignment &&
        (!hasNoWorkers || !hasPassedTransferDelay) &&
        !isRestarting &&
        !isRedetecting && <VideoNotification message='Waiting for GPU...' />}
      {!hasAssignment && !hasNoWorkers && isRestarting && (
        <VideoNotification
          /* @ts-ignore */
          message='Searching for subjects...'
        />
      )}
      {!!hasAssignment && !isConnected && <VideoNotification message='Connecting to GPU...' />}
      {!isReturningToSafePosition &&
        !!hasAssignment &&
        !!isConnected &&
        !hasAnnotations &&
        !isRedetecting && <VideoNotification message='Searching for subjects...' />}
      {!!hasAssignment &&
        !!isConnected &&
        !!hasAnnotations &&
        !isTracking &&
        !isRedetecting &&
        !wantsTracking &&
        !isAnnotationSelected && (
          <VideoNotification message='Select a Subject to Track' variant='success' />
        )}
      {!!isRedetecting && (
        <VideoNotification
          canClose
          message={`Redetecting... ${redetectionCountdown}`}
          onClose={() => handleStopTrackingSelectedSubject()}
        />
      )}

      {!!isReturningToSafePosition && !hasAnnotations && (
        <VideoNotification
          message={`Subject Lost. Returning to safe position${
            safePositionCountdown !== 0 ? ` in ${safePositionCountdown}` : ''
          }...`}
        />
      )}
    </>
  );
};
